import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/develops",
      name: "develops",
      component: () =>
        import(/* webpackChunkName: "develop" */ "./views/Develop.vue")
    },
    {
      path: "/designs",
      name: "designs",
      component: () =>
        import(/* webpackChunkName: "design" */ "./views/Design.vue")
    },
    {
      path: "/authors",
      name: "authors",
      component: () =>
        import(/* webpackChunkName: "author" */ "./views/Author.vue")
    },
    {
      path: "/draws",
      name: "draws",
      component: () => import(/* webpackChunkName: "draw" */ "./views/Draw.vue")
    },
    {
      path: "/wroteabook",
      name: "wroteabook",
      component: () =>
        import(/* webpackChunkName: "wroteabook" */ "./views/WroteABook.vue")
    }
  ]
});
